export const ErrorUI = () => {
	return <div>Something went wrong</div>;
};
